
    export enum EnumDpm {
			Dairy = 0,
			DairyFish = 1,
			DairyEquipment = 2,
			Fish = 3,
			Glatt = 4,
			Meat = 5,
			NonKosher = 6,
			Pareve = 7,
			PareveFish = 8,
			GlattMeat = 9,
			OUFish = 10,
			OUGlatt = 11,
			OUD = 12,
			OU = 13,
    }